module.exports = __webpack_public_path__ + "img/Character_Tighnari_Thumb.aa764e53.png";